import { BackgroundStyle, ForegroundStyle, BorderSize, BorderStyle } from '../../Style';
export var ToggleButtonType;
(function (ToggleButtonType) {
    ToggleButtonType["Secondary"] = "secondary";
})(ToggleButtonType || (ToggleButtonType = {}));
export const ToggleButtonTypeClass = {
    [ToggleButtonType.Secondary]: `${BackgroundStyle.Secondary} ${BackgroundStyle.Outline} ${ForegroundStyle.OutlineElements} ${BorderSize.Solid1} ${BorderStyle.General}`
};
